/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { Container, Context, ViewForm } from './styles';
import tutoria from '~/assets/images/tutoring.png';
import api from '~/services/api';

export default function Tutoring() {
  const id = useSelector((state) => state.user.profile.id);
  const [user, setUser] = useState('');
  const [tutor, setTutor] = useState('');
  const [disciple, setDisciple] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`users/${id}`);

      setUser(data);
    }
    getData();
  }, [id]);

  async function handleSubmitDisciple(e) {
    e.preventDefault();
    try {
      await api.put('/student/disciples', { disciple_description: disciple });
      const { data } = await api.get(`users/${id}`);
      setUser(data);
      setDisciple('');
      return toast.success('Solicitado tutor com sucesso!');
    } catch (error) {
      return toast.error('Falha em solicitar um tutor, tente novamente.');
    }
  }

  async function handleSubmitTutor(e) {
    e.preventDefault();
    try {
      await api.put('/student/tutorings', { tutor_description: tutor });
      const { data } = await api.get(`users/${id}`);
      setUser(data);
      setTutor('');
      return toast.success('Solicitaçāo para ser tutor realizado!');
    } catch (error) {
      return toast.error(
        'Falha em solicitar para ser um tutor, tente novamente.'
      );
    }
  }

  return (
    <>
      <h1 style={{ color: '#36ded6', marginLeft: 30 }}>Tutoria</h1>
      <Container>
        <Context>
          <img src={tutoria} alt="tutoria" />
          <p style={{ fontSize: 14 }}>
            A Tutoria Apollo faz parte do nosso método de trabalho e de contínuo
            aprendizado que todas as pessoas que trabalham com tecnologia deve
            ter. Quando ensinamos alguém, além de fazermos uma enorme diferença
            na aprendizagem dessa pessoa, reforçamos nosso conhecimento e
            aprendemos ainda mais. Por isso encorajamos a todos os Apollo
            Partners se inscreverem para solicitar um tutor e também de
            candidatar para ser um tutor.
          </p>
          <p style={{ fontSize: 14, marginTop: 8, fontWeight: 'bold' }}>
            Peça um tutor:
          </p>
          <p style={{ fontSize: 14, marginTop: 5 }}>
            Se você quer uma ajuda no seu processo de aprendizado, peça por um
            tutor. Alguém que já passou por onde você está poderá te ajudar com
            dicas, conceitos e claro com os bugs que irāo aparecer.
          </p>
          <p style={{ fontSize: 14, marginTop: 8, fontWeight: 'bold' }}>
            Seja um tutor:
          </p>
          <p style={{ fontSize: 14, marginTop: 5 }}>
            Se você quer ajudar alguém que está aprendendo tecnologias que você
            já conhece, se candidate para se tornar um tutor. Você nāo precisa
            ter anos de experiência para ensinar alguém, você precisa de alguém
            engajado a aprender e absorver as lições que você tem a passar.
          </p>
          {/* <p className="description">1 - Aqui a gente vai colocar um texto</p>
          <p className="description">2 - Outro texto aqui também</p>
          <p className="description">3 - Esse vai encerrar</p> */}
        </Context>
        <ViewForm>
          <p className="disciple">Quero SOLICITAR um tutor!</p>
          <form className="disciple" onSubmit={handleSubmitDisciple}>
            <textarea
              name="disciple"
              id="disciple"
              cols="30"
              rows="10"
              placeholder="Digite o que você espera do seu tutor"
              value={disciple}
              onChange={(e) => setDisciple(e.target.value)}
            />
            {user.disciple === false ? (
              <button type="submit">SOLICITAR TUTOR</button>
            ) : (
              <button type="submit" disabled>
                TUTOR JÁ SOLICITADO
              </button>
            )}
          </form>
          <p className="tutoring">Quero SER um tutor!</p>
          <form className="tutoring" onSubmit={handleSubmitTutor}>
            <textarea
              name="tutor"
              id="tutor"
              cols="30"
              rows="10"
              placeholder="Digite como você pode contribuir para ser um tutor"
              value={tutor}
              onChange={(e) => setTutor(e.target.value)}
            />
            {user.tutor === false ? (
              <button type="submit">ME TORNAR TUTOR</button>
            ) : (
              <button type="submit" disabled>
                PEDIDO JÁ SOLICITADO
              </button>
            )}
          </form>
        </ViewForm>
      </Container>
    </>
  );
}
